import React from "react"
import {connect} from "react-redux";
import createReactClass from 'create-react-class';
import {Grid, Row, Col, Modal, Button, DropdownButton} from "react-bootstrap";
import {getUrlParams, redirectPage} from "../../common/utils";
import LoadingAnimation from "../../components/common/LoadingAnimation";
import {setPastSeasonMessage, getSignupData, initGuestUser, gotoStep, getStepLabel} from "../../actions/join/joinActions";
import {setAndRemoveUrlParams} from "../../actions/common/commonActions";
import JoinWizardSteps from "../../components/join/JoinWizardSteps";
import JoinNavigationButtons from "./JoinNavigationButtons";
import PickupSiteSelection from "../common/PickupSiteSelection";
import JoinSharesOptionsStep from "./JoinSharesOptionsStep";
import JoinTermsStep from "./JoinTermsStep";
import JoinContactInfoStep from "./JoinContactInfoStep";
import JoinPayStep from "./JoinPayStep"
import JoinSummary  from "./JoinSummary";
import PaymentsHost from "../pay/PaymentsHost";
import {JoinSteps, JoinModes, URLs, FetchingTypes} from "../../common/constants";
import {initServerStaticData} from "../../actions/common/staticDataActions";
import ThankYouPage from "../../components/common/ThankYouPage";
import EcheckForm from "../pay/EcheckForm";
import EBTForm from "../pay/EBTForm";
import MessagePage from "../../components/common/MessagePage";
import {getAddSubscriptionData, isAddSubscription} from "../../actions/common/subscriptionSummaryActions";
import {initMemberData} from "../../actions/login/memberDetailsActions";
import {isFetching} from "../../actions/common/fetchingActions";
import UserMenu from '../common/UserMenu';
import {translate} from '../../i18n/translate.js';
import styles from "../../css/join/joinHomeScreen.less";
import {
    calcTotals,
    getAllItemsRemainingDeliveryDates,
    getJoinSelectedItems,
    getNextDeliveryDate
} from "../../common/basket";

const JoinHomeScreen = createReactClass({
    getInitialState(){
        if (this.props.staticData.farmUrl)
        //Module is already initialized
            return {};
        this.props.initServerStaticData();
        const isGuestUser = this.isGuestUser();
        if(!isGuestUser) {
            this.props.initMemberData();
        }
        const isAddSubscription = this.isAddSubscription();

        if(this.props.location.pathname.includes('/thankyou'))
        //No need to load data
            return {};

        if(!isGuestUser) {
            if (isAddSubscription)
                this.props.getAddSubscriptionData(getUrlParams().s);
            else
                this.props.getSignupData(JoinModes.NEW);
        }
        return {};
    },
    isPastSeason() {
        return window.Farmigo.serverData.isPastSeason;
    },
    isGuestUser() {
        if (getUrlParams().mode === 'guest') {
            this.props.initGuestUser();
            this.props.gotoStep(JoinSteps.CONTACT_INFO);
            if(this.isPastSeason()) {
                this.props.setPastSeasonMessage();
            }
            return true;
        }
        return false;
    },
    componentWillMount() {
        this.props.setAndRemoveUrlParams(true);
    },
    componentWillReceiveProps(nextProps) {
        if(!this.props.data && nextProps.data && !nextProps.isWaitListOnly && this.isPastSeason()) {
            this.props.setPastSeasonMessage();
        }
    },
    isAddSubscription() {
        return isAddSubscription();
    },
    showSummaryModal() {
        this.setState({showSummary: true});
    },
    closeSummaryModal() {
        this.setState({showSummary: false});
    },
    getJoinHeader() {
        return (<div>
            <div className="join-header">
                <div
                    className="join-header-title">{(this.props.staticData.joinWizardSignupLabel || translate("Sign Up")) + (this.props.seasonTitle ? (" : " + this.props.seasonTitle) : "")}</div>
                <JoinNavigationButtons/>
            </div>
            <div>
                <JoinWizardSteps step={this.props.step} steps={this.props.steps} isGuestUser={this.props.isGuestUser}
                                 staticData={this.props.staticData} isWaitListOnly={this.props.isWaitListOnly}/>
            </div>
        </div>);
    },
    getJoinHeaderMobile() {
        return (<div className="join-header-mobile">
            <JoinNavigationButtons>
                <JoinWizardSteps step={this.props.step} steps={this.props.steps} isGuestUser={this.props.isGuestUser}
                                 staticData={this.props.staticData} isWaitListOnly={this.props.isWaitListOnly}
                                 hideLabel={true}/>
            </JoinNavigationButtons>
            <div className="title-container">
                {this.props.seasonTitle ?
                    <div className="join-header-title">{this.props.seasonTitle}</div>
                    : undefined
                }
                <div id="joinHeaderSubtitle"
                     className={"join-header-subtitle" + (!this.props.seasonTitle ? " no-title" : "")}>{getStepLabel(this.props.step, this.props.staticData.pickupSiteLabel, this.props.isWaitListOnly, this.props.isGuestUser, this.props.staticData.joinSharesStepLabel)}</div>
            </div>
            <Button id="btnSummary" bsStyle="primary" className="join-header-summary-button navigation-btn"
                    onClick={this.showSummaryModal}>Summary</Button>
        </div>);
    },

    getStepScreen(step) {
        switch (step) {
            case JoinSteps.PICKUP_SITES:
                return <PickupSiteSelection flowType={URLs.JOIN}/>;
            case JoinSteps.SHARES:
            case JoinSteps.OPTIONS:
                return <JoinSharesOptionsStep isAddSubscription={this.props.isAddSubscription}/>;
            case JoinSteps.TERMS:
                return <JoinTermsStep/>;
            case JoinSteps.CONTACT_INFO:
                return <JoinContactInfoStep staticData={this.props.staticData}/>;
            case JoinSteps.PAY:
                return <JoinPayStep/>;
            case JoinSteps.THANK_YOU:
                return (<ThankYouPage pageContext={URLs.JOIN} seasonUrl={this.props.staticData.seasonUrl}
                                      customConfirmationScript={this.props.staticData.customConfirmationScript}
                                      isWaitListOnly={this.props.isWaitListOnly}
                                      farmUrl={this.props.staticData.farmUrl}
                                      memberKey={this.props.memberDetails.key}
                                      staticData={this.props.staticData}
                                      extraMessage={(this.props.staticData.params || {}).message}
                                      amountText={this.props.amountText}
                                      mode={this.props.isAddSubscription ? JoinModes.ADD : JoinModes.NEW}/>);
        }
    },
    getPath() {
        window.location.replace(redirectPage(URLs.JOIN, this.props.staticData));
    },
    getScreen(){
        if (this.props.showLoading)
            return <LoadingAnimation/>;
        const path = this.props.location.pathname;
        if (path.includes('/thankyou') || this.props.step === JoinSteps.THANK_YOU) {
            return this.getStepScreen(JoinSteps.THANK_YOU);
        }
        if (path.endsWith('/echeck')) {
            if (!this.props.selectedPickupSite) {
                this.getPath();
                return <LoadingAnimation/>;
            } else {
                return (<EcheckForm pageContext={URLs.JOIN}/>);
            }
        }
        if (path.endsWith('/ebt')) {
            if (!this.props.selectedPickupSite) {
                this.getPath();
                return <LoadingAnimation/>;
            } else {
                return (<EBTForm pageContext={URLs.JOIN}/>);
            }
        }
        if (path.endsWith('/payments')) {
            if (!this.props.selectedPickupSite) {
                this.getPath();
                return <LoadingAnimation/>;
            } else {
                return (<PaymentsHost pageContext={URLs.JOIN}/>);
            }
        }
        if (this.props.messageData.messageTitle)
            return (<MessagePage messageData={this.props.messageData}
                                 staticData={this.props.staticData}
                                 memberKey={this.props.memberDetails.key}/>);
        if (this.props.clientViewPort.isXs)
            return (<div>
                {this.getJoinHeaderMobile()}
                <div className="steps-wrapper">
                    {this.getStepScreen(this.props.step)}
                </div>
                <Modal show={this.state.showSummary} onHide={this.closeSummaryModal} className="summary-modal">
                    <Modal.Body>
                        <JoinSummary step={this.props.step} isAddSubscription={this.props.isAddSubscription}/>
                    </Modal.Body>
                    <button id="btnCloseSummaryPopup" className="close-button order-summary-popup visible-xs"
                            onClick={this.closeSummaryModal}/>
                </Modal>
            </div>);
        return (<Grid className="join-container">
            <Row>
                <Col lg={8} md={10} sm={10}>
                    {this.getJoinHeader()}
                    {this.getStepScreen(this.props.step)}
                </Col>
                <Col className="summary-col" lg={4} md={2} sm={2}>
                    <div className="user-menu-wrapper">
                        {this.props.memberDetails.key ?
                            <UserMenu />
                            :
                            <div className="user-menu-space"/>
                        }
                    </div>
                    {this.props.clientViewPort.isLg ?
                        <JoinSummary step={this.props.step} isAddSubscription={this.props.isAddSubscription}/>
                        :
                        <DropdownButton id="summary-dropdown" title="Summary" pullRight={true} noCaret={true}
                                        bsStyle="default">
                            <JoinSummary step={this.props.step} isAddSubscription={this.props.isAddSubscription}/>
                        </DropdownButton>
                    }
                </Col>
            </Row>
        </Grid>);
    },
    render() {
        if (!this.props.staticData.farmUrl)
        //static data was not loaded yet
            return null;
        return (
            this.getScreen()
        );
    }
});

const mapStateToProps = (state) => {
    const signupData = (state.signupData||{});
    const clientViewPort= (state.clientViewPort || {});
    let amountText = "";

    if (state.staticData.addAmountToSignupConfirmationScript &&
        (signupData.step === JoinSteps.THANK_YOU || signupData.step === JoinSteps.PAY)) {
        try {
            const summary = state.summary || {};
            const sharesData = signupData.sharesData || {};
            const selectedItems = getJoinSelectedItems(sharesData.shares, sharesData.options);
            const selectedData = (signupData.selectedData || {});
            const nextDeliveryDate = getNextDeliveryDate(summary.pickupSite, selectedItems,
                signupData.schedules, signupData.pickupSitesData.nextDeliveryDates);
            const itemsRemainingDates = getAllItemsRemainingDeliveryDates(selectedItems.items, signupData.sharesData.remainingScheduleDates);
            amountText = calcTotals(signupData.data.isFarmSeasonal, summary.pickupSite, selectedItems.items, selectedData.selectedPaymentPlan,
                selectedData.coupon, itemsRemainingDates, signupData.sharesData.remainingScheduleDates,
                nextDeliveryDate, signupData.isAddSubscription, summary.discount, state.staticData, selectedData.selectedMethod).priceText;
        } catch (e) {}
    }
    return {
        clientViewPort: clientViewPort,
        staticData: state.staticData,
        showLoading: isFetching(state, FetchingTypes.LOAD_SIGNUP_DATA)
        || isFetching(state, FetchingTypes.GET_STATUS)
        || isFetching(state, FetchingTypes.CREATE_SUBSCRIPTION),
        data: signupData.data,
        pickupSitesData: signupData.pickupSitesData,
        steps: (signupData.steps || []),
        step: signupData.step,
        isWaitListOnly: (signupData.data || {}).isWaitListOnly,
        isGuestUser: signupData.isGuestUser,
        isAddSubscription: signupData.isAddSubscription,
        messageData: (state.messageData || {}),
        memberDetails: (state.memberDetails || {}),
        seasonTitle: (state.staticData.isFarmSeasonal || !clientViewPort.isXs) ? ((signupData.data || {}).seasonTitle) : undefined,
        selectedPickupSite: (state.summary || {}).pickupSite,
        amountText: amountText
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        initServerStaticData: () => {
            dispatch(initServerStaticData());
        },
        initMemberData: () => {
            dispatch(initMemberData());
        },
        setAndRemoveUrlParams: (onlyHidden) => {
            dispatch(setAndRemoveUrlParams(onlyHidden));
        },
        setPastSeasonMessage: () => {
            dispatch(setPastSeasonMessage());
        },
        getSignupData: (mode) => {
            dispatch(getSignupData(mode));
        },
        initGuestUser: () => {
            dispatch(initGuestUser());
        },
        getAddSubscriptionData: (subscriptionKey) => {
            dispatch(getAddSubscriptionData(subscriptionKey));
        },
        gotoStep: (step) => {
            dispatch(gotoStep(step));
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps) (JoinHomeScreen);


// WEBPACK FOOTER //
// ./src/containers/join/JoinHomeScreen.js